/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react'
import Select, { components } from 'react-select'

export const SelectContentSearchMulti = ({
  id = '',
  value = [], // agora é array
  setValue,
  field = null,
  disabled = null,
  required = false,
  options = [],
  placeholder = 'Selecione uma ou mais opções...',
  styleControl = {},
  limitOptions = 20,
  showSelectAllButton = false, // <--- novo parâmetro
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [highlightedOption, setHighlightedOption] = useState(null)

  const filteredOptions = options
    .filter((option) => option.label.toLowerCase().includes(searchTerm.toLowerCase()))
    .slice(0, limitOptions)

  const changeValue = (newValues) => {
    if (field) {
      setValue({
        ...value,
        [field]: newValues.map((v) => v.value), // salva só os values
      })
    } else {
      setValue(newValues.map((v) => v.value))
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      if (highlightedOption) {
        let newValues
        if (field) {
          const current = value[field] || []
          newValues = [...current, highlightedOption.value]
          setValue({ ...value, [field]: newValues })
        } else {
          newValues = [...(value || []), highlightedOption.value]
          setValue(newValues)
        }
      }
    }
  }

  const handleMenuOpen = () => {
    setHighlightedOption(null)
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '50px',
      borderColor: '#dbdbdb',
      padding: '0.25rem 0.735rem',
      minHeight: '42px',
      fontSize: '14px',
      boxShadow: 'none',
      ...styleControl,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#3273dc' : 'white',
      color: state.isFocused ? 'white' : '#363636',
      fontSize: '14px',
    }),
  }

  const optionValue = () => {
    if (field) {
      const selected = value?.[field] || []
      return options.filter((opt) => selected.includes(opt.value))
    } else {
      return options.filter((opt) => value.includes(opt.value))
    }
  }

  // Componente customizado para injetar botão "Selecionar todos"
  const MenuList = (props) => (
    <>
      {showSelectAllButton && filteredOptions.length > optionValue().length && (
        <div
          style={{
            padding: '8px 12px',
            cursor: 'pointer',
            fontWeight: 'bold',
            color: '#3273dc',
          }}
          onClick={() => {
            // Seleciona todos os options visíveis (filteredOptions)
            const all = filteredOptions.map((opt) => opt.value)
            if (field) {
              setValue({ ...value, [field]: all })
            } else {
              setValue(all)
            }
          }}
        >
          Selecionar todos
        </div>
      )}
      <components.MenuList {...props}>{props.children}</components.MenuList>
    </>
  )

  return (
    <Select
      id={id}
      options={filteredOptions}
      value={optionValue()}
      onChange={changeValue}
      onInputChange={(val) => setSearchTerm(val)}
      placeholder={placeholder}
      isSearchable={true}
      isMulti={true}
      isDisabled={disabled}
      isRequired={required}
      styles={customStyles}
      onKeyDown={handleKeyDown}
      onMenuOpen={handleMenuOpen}
      components={{ MenuList }} // injeta menu customizado
    />
  )
}
